import React from 'react';
import { ClipboardList, ChevronRight } from 'lucide-react';
import { Link } from '@inertiajs/react';
import { useTranslation } from 'react-i18next';

import { useThemeColors } from '@/hooks/useThemeColors';
import { AssignmentSummary } from '@/types';

interface AssignmentListItemProps {
    assignment: AssignmentSummary;
}

const AssignmentListItem: React.FC<AssignmentListItemProps> = ({ assignment }) => {
    const { t } = useTranslation();
    const colors = useThemeColors();

    return (
        <Link
            href={`/assignments/${assignment.slug}/`}
            className="group flex items-center justify-between rounded-lg px-4 py-3 transition-all duration-150 hover:bg-white dark:hover:bg-neutral-700"
        >
            <div className="flex items-center space-x-3">
                <ClipboardList size={16} className="text-emerald-500" />
                <div>
                    <h4 className={`font-medium text-gray-900 dark:text-white group-hover:${colors.iconColor}`}>
                        {assignment.title}
                    </h4>
                    <p className="text-xs text-gray-500 dark:text-neutral-400">
                        {t('course.assignment')}
                    </p>
                </div>
            </div>
            <ChevronRight size={16} className={`text-gray-400 dark:text-neutral-500 transition-colors group-hover:${colors.iconColor}`} />
        </Link>
    );
};

export default AssignmentListItem;
